import { IntervalTypeId as IntervalTypeId$1, make as make$1, empty as empty$1, lessThan as lessThan$1, min as min$1, max as max$1, isEmpty as isEmpty$1, isNonEmpty as isNonEmpty$1, intersect as intersect$1, size as size$1, union as union$1, after as after$1, before as before$1 } from '../../internal/schedule/interval.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const IntervalTypeId = IntervalTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * An `Interval` represents an interval of time. Intervals can encompass all
 * time, or no time at all.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Constructs a new interval from the two specified endpoints. If the start
 * endpoint greater than the end endpoint, then a zero size interval will be
 * returned.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * An `Interval` of zero-width.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Returns `true` if this `Interval` is less than `that` interval, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const lessThan = lessThan$1;

/**
 * Returns the minimum of two `Interval`s.
 *
 * @since 2.0.0
 * @category ordering
 */
const min = min$1;

/**
 * Returns the maximum of two `Interval`s.
 *
 * @since 2.0.0
 * @category ordering
 */
const max = max$1;

/**
 * Returns `true` if the specified `Interval` is empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const isEmpty = isEmpty$1;

/**
 * Returns `true` if the specified `Interval` is non-empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const isNonEmpty = isNonEmpty$1;

/**
 * Computes a new `Interval` which is the intersection of this `Interval` and
 * that `Interval`.
 *
 * @since 2.0.0
 * @category ordering
 */
const intersect = intersect$1;

/**
 * Calculates the size of the `Interval` as the `Duration` from the start of the
 * interval to the end of the interval.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Computes a new `Interval` which is the union of this `Interval` and that
 * `Interval` as a `Some`, otherwise returns `None` if the two intervals cannot
 * form a union.
 *
 * @since 2.0.0
 * @category utils
 */
const union = union$1;

/**
 * Construct an `Interval` that includes all time equal to and after the
 * specified start time.
 *
 * @since 2.0.0
 * @category constructors
 */
const after = after$1;

/**
 * Construct an `Interval` that includes all time equal to and before the
 * specified end time.
 *
 * @category constructors
 * @since 2.0.0
 */
const before = before$1;

export { IntervalTypeId, after, before, empty, intersect, isEmpty, isNonEmpty, lessThan, make, max, min, size, union };
